import { CenterItem } from '@components/LinearLayout';
import { EVENT_HOME_WIDTH } from '@utils/constants';
import { P } from '@components/Typography';
import styled from 'styled-components';

export const AgendaDatesRoot = styled.div<{ $color?: string }>`
  display: flex;
  justify-content: center;
  gap: 1rem;
  width: min(${EVENT_HOME_WIDTH}, 100%);

  margin: auto;
  margin-top: 5rem;
  margin-bottom: 3rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding-left: 2rem;
    padding-right: 2rem;

    ${({ $color }) =>
      $color &&
      `
        width: min(90%, 100%);
      `}
  }
`;

export const DayItem = styled(CenterItem)<{
  $active: boolean;
  $isFirstItem: boolean;
  $isLastItem: boolean;
  $color?: string;
}>`
  flex: 1 1 20rem;
  width: 100%;

  background-color: ${({ $active, $color, theme }) =>
    $color
      ? $active
        ? $color
        : theme.color.white
      : $active
        ? theme.color.mobilityGrey
        : theme.color.lightGrey2};

  border-top-left-radius: ${({ $isFirstItem, theme }) =>
    $isFirstItem && theme.borderRadius.radius10};
  border-bottom-left-radius: ${({ $isFirstItem, theme }) =>
    $isFirstItem && theme.borderRadius.radius10};
  border-top-right-radius: ${({ $isLastItem, theme }) =>
    $isLastItem && theme.borderRadius.radius10};
  border-bottom-right-radius: ${({ $isLastItem, theme }) =>
    $isLastItem && theme.borderRadius.radius10};

  padding: 2rem;

  &:hover {
    background-color: ${({ $color, theme }) =>
      $color ?? theme.color.mobilityGrey};
    cursor: pointer;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    ${({ theme }) => `
      border-radius: ${theme.borderRadius.radius20};
      padding: 3rem 1rem;
    `}
  }
`;

export const DayText = styled(P)<{
  $active: boolean;
  $isHovered: boolean;
  $color?: string;
}>`
  display: flex;
  flex-direction: row;

  font-size: ${({ theme }) => theme.fontSize.size20};
  font-weight: ${({ theme }) => theme.fontWeight.weight700};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  text-align: center;

  color: ${({ $active, $isHovered, theme, $color }) => {
    if ($color) {
      return $active || $isHovered
        ? theme.color.white
        : theme.color.mobilityGrey;
    }
    return $active || $isHovered ? theme.color.white : theme.color.mobilityGrey;
  }};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    flex-direction: column;
    font-size: ${({ theme }) => theme.fontSize.size16};

    ${({ $color }) =>
      $color &&
      `
        padding-left: 4rem;
        padding-right: 4rem;
      `}
    ${({ $color, $active }) =>
      $color &&
      !$active &&
      `
        color: white;
      `}
  }
`;
